import { IntlProvider } from "react-intl";
import { ReactNode } from "react";
import { messages } from "./messages";

type Props = {
	locale: "en" | "de" | "fr";
	children: ReactNode;
};

export const IntlWrapper = ({ locale, children }: Props) => {
	return (
		//@ts-ignore
		<IntlProvider locale={locale} messages={messages[locale]}>
			{children}
		</IntlProvider>
	);
};
